module.exports = {
      id: "pause-usage",
      viewBox: "0 0 31 30",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#pause",
      toString: function () {
        return this.url;
      }
    }